import { render, staticRenderFns } from "./DietRecord.vue?vue&type=template&id=142ade11&scoped=true"
import script from "./DietRecord.vue?vue&type=script&lang=js"
export * from "./DietRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ade11",
  null
  
)

export default component.exports